import clsx from 'clsx';
import * as React from 'react';
import {
  T,
  TPlainTextKey,
  translation,
  TranslationsContext,
  TranslationsState,
} from '../../../Translations';

type ButtonType = 'submit' | 'reset' | 'button';

interface Props {
  type: ButtonType;
  value: TPlainTextKey;
  name?: TPlainTextKey;
  className?: string;
  onClick(event?: React.FormEvent<EventTarget>): void;
  dataTestDeleteButton?: boolean;
  dataTestSaveButton?: boolean;
  id?: string;
  disabled?: boolean;
  intercomTarget?: string;
}

const buttonImpl = (props: Props) => (ts: TranslationsState) => (
  <button
    type={props.type}
    name={props.name ? translation(props.name)(ts) : undefined}
    className={
      props.className
        ? props.className
        : clsx(
            'inline-block cursor-pointer whitespace-nowrap text-center',
            'rounded-sm border-solid border-transparent py-2 px-4 font-light tracking-wide',
            'w-full bg-green-600 text-sm text-white hover:bg-gray-500',
          )
    }
    data-test-delete-button={props.dataTestDeleteButton}
    data-test-save-button={props.dataTestSaveButton}
    data-test-button={props.value}
    data-intercom-target={props.intercomTarget}
    id={props.id}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    <T kind={props.value} />
  </button>
);

class Button extends React.PureComponent<Props> {
  render() {
    return <TranslationsContext.Consumer>{buttonImpl(this.props)}</TranslationsContext.Consumer>;
  }
}

export default Button;
